import { Button, Divider, Group, Stack, Text, TextInput } from "@mantine/core";
import { IconAlertTriangle, IconDownload } from "@tabler/icons-react";
import React from "react";

const dividerWeight = 600;
const labelWeight = 500;

const SubMcProject: React.FC<{
  onFetchFromMaconomy: (subProjectNo: string) => void;
  failed: boolean;
}> = ({ onFetchFromMaconomy, failed }) => {
  const [subProjectNo, setSubProjectNo] = React.useState<string>("");

  return (
    <Stack gap="xs">
      <Divider
        label={
          <Text fz="lg" fw={dividerWeight}>
            Deloppgave
          </Text>
        }
        labelPosition="center"
        mb="xs"
      />
      <Group grow align="center">
        <Text fw={labelWeight}>Deloppgavenummer:</Text>
        <TextInput
          placeholder="Angi to tall (02, 03 …)"
          size="sm"
          value={subProjectNo}
          onChange={(e) => setSubProjectNo(e.target.value)}
        />
        <Button
          leftSection={<IconDownload size={16} />}
          onClick={() => onFetchFromMaconomy(subProjectNo)}
          style={{
            opacity: subProjectNo.length === 2 ? 1 : 0.35,
            pointerEvents: subProjectNo.length === 2 ? "auto" : "none",
            transition: "opacity 150ms ease",
          }}
        >
          Last ned
        </Button>
      </Group>
      {failed && (
        <Group gap="xs" mt="xs">
          <IconAlertTriangle size={16} color="red" />
          <Text c="red" size="sm">
            Kunne ikke hente data fra Maconomy. Er du sikker på at du har angitt riktig deloppgave?
          </Text>
        </Group>
      )}
    </Stack>
  );
};

export default SubMcProject;
